/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type InvsysColorType =
  | 'BLACK'
  | 'BLUE'
  | 'BROWN'
  | 'CREAM'
  | 'GOLD'
  | 'GRAY'
  | 'GREEN'
  | 'ORANGE'
  | 'PINK'
  | 'PURPLE'
  | 'RED'
  | 'SILVER'
  | 'TAN'
  | 'WHITE'
  | 'YELLOW'
  | '%future added value';
export type InvsysListingConditionType =
  | 'NEW_WITHOUT_TAGS'
  | 'NEW_WITH_DEFECTS'
  | 'NEW_WITH_TAGS'
  | 'POOR'
  | 'PRE_OWNED'
  | '%future added value';
export type InvsysListingCurrencyCodeType = 'AUD' | 'CAD' | 'USD' | '%future added value';
export type InvsysSizeUnitType = 'CENTIMETERS' | 'INCHES' | '%future added value';
export type InvsysWeightUnitType = 'GRAMS' | 'KILOGRAMS' | 'OUNCES' | 'POUNDS' | '%future added value';
export type InvsysStringPutObject = {
  value?: string | null;
};
export type InvsysArray_StringRequired_RequiredPutObject = {
  value: Array<string>;
};
export type InvsysFloatPutObject = {
  value?: number | null;
};
export type InvsysListingCurrencyCodeTypePutObject = {
  value?: InvsysListingCurrencyCodeType | null;
};
export type InvsysBooleanPutObject = {
  value?: boolean | null;
};
export type InvsysArray_IntRequired_PutObject = {
  value?: Array<number> | null;
};
export type InvsysArray_PutItemOperationRequired_RequiredPutObject = {
  value: Array<InvsysPutItemOperation>;
};
export type InvsysPutItemOperation = {
  id: string;
  title?: InvsysStringPutObject | null;
  description?: InvsysStringPutObject | null;
  mediaIds?: InvsysArray_StringRequired_RequiredPutObject | null;
  condition?: InvsysListingConditionTypePutObject | null;
  brand?: InvsysStringPutObject | null;
  retailPrice?: InvsysFloatPutObject | null;
  costPrice?: InvsysFloatPutObject | null;
  colors?: InvsysArray_ColorTypeRequired_RequiredPutObject | null;
  tags?: InvsysArray_StringRequired_RequiredPutObject | null;
  notes?: InvsysArray_StringRequired_RequiredPutObject | null;
  skuAlias?: InvsysStringPutObject | null;
  currencyCode?: InvsysListingCurrencyCodeTypePutObject | null;
  weight?: InvsysFloatPutObject | null;
  packageSizeType?: InvsysIntPutObject | null;
  width?: InvsysFloatPutObject | null;
  length?: InvsysFloatPutObject | null;
  height?: InvsysFloatPutObject | null;
  sizeUnit?: InvsysSizeUnitTypePutObject | null;
  weightUnit?: InvsysWeightUnitTypePutObject | null;
  categoryId?: InvsysStringPutObject | null;
  sizeId?: InvsysStringPutObject | null;
};
export type InvsysListingConditionTypePutObject = {
  value?: InvsysListingConditionType | null;
};
export type InvsysArray_ColorTypeRequired_RequiredPutObject = {
  value: Array<InvsysColorType>;
};
export type InvsysIntPutObject = {
  value?: number | null;
};
export type InvsysSizeUnitTypePutObject = {
  value?: InvsysSizeUnitType | null;
};
export type InvsysWeightUnitTypePutObject = {
  value?: InvsysWeightUnitType | null;
};
export type putListingMutationVariables = {
  id?: string | null;
  title?: InvsysStringPutObject | null;
  description?: InvsysStringPutObject | null;
  skus?: InvsysArray_StringRequired_RequiredPutObject | null;
  tags?: InvsysArray_StringRequired_RequiredPutObject | null;
  notes?: InvsysArray_StringRequired_RequiredPutObject | null;
  mediaIds?: InvsysArray_StringRequired_RequiredPutObject | null;
  listingSku?: InvsysStringPutObject | null;
  price?: InvsysFloatPutObject | null;
  currencyCode?: InvsysListingCurrencyCodeTypePutObject | null;
  weight?: InvsysFloatPutObject | null;
  width?: InvsysFloatPutObject | null;
  length?: InvsysFloatPutObject | null;
  height?: InvsysFloatPutObject | null;
  archived?: InvsysBooleanPutObject | null;
  userDeleted?: InvsysBooleanPutObject | null;
  targetInstitutions?: InvsysArray_IntRequired_PutObject | null;
  searchTags?: InvsysArray_StringRequired_RequiredPutObject | null;
  itemOperations?: InvsysArray_PutItemOperationRequired_RequiredPutObject | null;
};
export type putListingMutationResponse = {
  readonly invsysPutListing: {
    readonly success: boolean;
    readonly data: {
      readonly ' $fragmentRefs': FragmentRefs<'listingFragment_full'>;
    } | null;
  };
};
export type putListingMutation = {
  readonly response: putListingMutationResponse;
  readonly variables: putListingMutationVariables;
};

/*
mutation putListingMutation(
  $id: String
  $title: InvsysStringPutObject
  $description: InvsysStringPutObject
  $skus: InvsysArray_StringRequired_RequiredPutObject
  $tags: InvsysArray_StringRequired_RequiredPutObject
  $notes: InvsysArray_StringRequired_RequiredPutObject
  $mediaIds: InvsysArray_StringRequired_RequiredPutObject
  $listingSku: InvsysStringPutObject
  $price: InvsysFloatPutObject
  $currencyCode: InvsysListingCurrencyCodeTypePutObject
  $weight: InvsysFloatPutObject
  $width: InvsysFloatPutObject
  $length: InvsysFloatPutObject
  $height: InvsysFloatPutObject
  $archived: InvsysBooleanPutObject
  $userDeleted: InvsysBooleanPutObject
  $targetInstitutions: InvsysArray_IntRequired_PutObject
  $searchTags: InvsysArray_StringRequired_RequiredPutObject
  $itemOperations: InvsysArray_PutItemOperationRequired_RequiredPutObject
) {
  invsysPutListing(id: $id, title: $title, description: $description, skus: $skus, tags: $tags, notes: $notes, mediaIds: $mediaIds, listingSku: $listingSku, price: $price, currencyCode: $currencyCode, weight: $weight, width: $width, length: $length, height: $height, archived: $archived, userDeleted: $userDeleted, targetInstitutions: $targetInstitutions, searchTags: $searchTags, itemOperations: $itemOperations) {
    success
    data {
      ...listingFragment_full
    }
  }
}

fragment listingFragment_full on InvsysSkusListing {
  id
  title
  description
  listingSku
  skus
  tags
  notes
  searchTags
  marketplacesSummary {
    marketplaces
    draftMarketplaces
  }
  price {
    id
    currencyCode
    val
  }
  createdAt
  updatedAt
  items {
    id
    title
    description
    brand
    categoryId
    sizeId
    price {
      currencyCode
      val
    }
    retailPrice {
      currencyCode
      val
    }
    costPrice {
      currencyCode
      val
    }
    size {
      val
      system
    }
    condition
    tags
    skuAlias
    colors
    weight
    height
    width
    length
    weightUnit
    sizeUnit
    packageSizeType
  }
  archived
  targetInstitutions
  validationResult {
    success
    errors {
      errorId: id
      message
      entityName
      fieldName
    }
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'archived',
    },
    v1 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'currencyCode',
    },
    v2 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'description',
    },
    v3 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'height',
    },
    v4 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'id',
    },
    v5 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'itemOperations',
    },
    v6 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'length',
    },
    v7 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'listingSku',
    },
    v8 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'mediaIds',
    },
    v9 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'notes',
    },
    v10 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'price',
    },
    v11 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'searchTags',
    },
    v12 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'skus',
    },
    v13 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'tags',
    },
    v14 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'targetInstitutions',
    },
    v15 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'title',
    },
    v16 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'userDeleted',
    },
    v17 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'weight',
    },
    v18 = {
      defaultValue: null,
      kind: 'LocalArgument',
      name: 'width',
    },
    v19 = [
      {
        kind: 'Variable',
        name: 'archived',
        variableName: 'archived',
      },
      {
        kind: 'Variable',
        name: 'currencyCode',
        variableName: 'currencyCode',
      },
      {
        kind: 'Variable',
        name: 'description',
        variableName: 'description',
      },
      {
        kind: 'Variable',
        name: 'height',
        variableName: 'height',
      },
      {
        kind: 'Variable',
        name: 'id',
        variableName: 'id',
      },
      {
        kind: 'Variable',
        name: 'itemOperations',
        variableName: 'itemOperations',
      },
      {
        kind: 'Variable',
        name: 'length',
        variableName: 'length',
      },
      {
        kind: 'Variable',
        name: 'listingSku',
        variableName: 'listingSku',
      },
      {
        kind: 'Variable',
        name: 'mediaIds',
        variableName: 'mediaIds',
      },
      {
        kind: 'Variable',
        name: 'notes',
        variableName: 'notes',
      },
      {
        kind: 'Variable',
        name: 'price',
        variableName: 'price',
      },
      {
        kind: 'Variable',
        name: 'searchTags',
        variableName: 'searchTags',
      },
      {
        kind: 'Variable',
        name: 'skus',
        variableName: 'skus',
      },
      {
        kind: 'Variable',
        name: 'tags',
        variableName: 'tags',
      },
      {
        kind: 'Variable',
        name: 'targetInstitutions',
        variableName: 'targetInstitutions',
      },
      {
        kind: 'Variable',
        name: 'title',
        variableName: 'title',
      },
      {
        kind: 'Variable',
        name: 'userDeleted',
        variableName: 'userDeleted',
      },
      {
        kind: 'Variable',
        name: 'weight',
        variableName: 'weight',
      },
      {
        kind: 'Variable',
        name: 'width',
        variableName: 'width',
      },
    ],
    v20 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'success',
      storageKey: null,
    },
    v21 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    v22 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'title',
      storageKey: null,
    },
    v23 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'description',
      storageKey: null,
    },
    v24 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'tags',
      storageKey: null,
    },
    v25 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'currencyCode',
      storageKey: null,
    },
    v26 = {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'val',
      storageKey: null,
    },
    v27 = [v25 /*: any*/, v26 /*: any*/],
    v28 = [
      v21 /*: any*/,
      v22 /*: any*/,
      v23 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'listingSku',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'skus',
        storageKey: null,
      },
      v24 /*: any*/,
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'notes',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'searchTags',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'InvsysListingMarketplacesSummary',
        kind: 'LinkedField',
        name: 'marketplacesSummary',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'marketplaces',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'draftMarketplaces',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'InvsysListingPriceType',
        kind: 'LinkedField',
        name: 'price',
        plural: false,
        selections: [v21 /*: any*/, v25 /*: any*/, v26 /*: any*/],
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'createdAt',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'updatedAt',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'InvsysSkuAttribute',
        kind: 'LinkedField',
        name: 'items',
        plural: true,
        selections: [
          v21 /*: any*/,
          v22 /*: any*/,
          v23 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'brand',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'categoryId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'sizeId',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysListingPriceType',
            kind: 'LinkedField',
            name: 'price',
            plural: false,
            selections: v27 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysListingPriceType',
            kind: 'LinkedField',
            name: 'retailPrice',
            plural: false,
            selections: v27 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysListingPriceType',
            kind: 'LinkedField',
            name: 'costPrice',
            plural: false,
            selections: v27 /*: any*/,
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            concreteType: 'InvsysListingSizeType',
            kind: 'LinkedField',
            name: 'size',
            plural: false,
            selections: [
              v26 /*: any*/,
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'system',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'condition',
            storageKey: null,
          },
          v24 /*: any*/,
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'skuAlias',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'colors',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'weight',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'height',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'width',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'length',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'weightUnit',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'sizeUnit',
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'packageSizeType',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'archived',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        kind: 'ScalarField',
        name: 'targetInstitutions',
        storageKey: null,
      },
      {
        alias: null,
        args: null,
        concreteType: 'InvsysListingStepResult',
        kind: 'LinkedField',
        name: 'validationResult',
        plural: false,
        selections: [
          v20 /*: any*/,
          {
            alias: null,
            args: null,
            concreteType: 'InvsysListingStepErrorType',
            kind: 'LinkedField',
            name: 'errors',
            plural: true,
            selections: [
              {
                alias: 'errorId',
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'message',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'entityName',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'fieldName',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: [
        v0 /*: any*/,
        v1 /*: any*/,
        v2 /*: any*/,
        v3 /*: any*/,
        v4 /*: any*/,
        v5 /*: any*/,
        v6 /*: any*/,
        v7 /*: any*/,
        v8 /*: any*/,
        v9 /*: any*/,
        v10 /*: any*/,
        v11 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v14 /*: any*/,
        v15 /*: any*/,
        v16 /*: any*/,
        v17 /*: any*/,
        v18 /*: any*/,
      ],
      kind: 'Fragment',
      metadata: null,
      name: 'putListingMutation',
      selections: [
        {
          alias: null,
          args: v19 /*: any*/,
          concreteType: 'InvsysPutListingResponse',
          kind: 'LinkedField',
          name: 'invsysPutListing',
          plural: false,
          selections: [
            v20 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'InvsysSkusListing',
              kind: 'LinkedField',
              name: 'data',
              plural: false,
              selections: [
                {
                  kind: 'InlineDataFragmentSpread',
                  name: 'listingFragment_full',
                  selections: v28 /*: any*/,
                },
              ],
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: [
        v4 /*: any*/,
        v15 /*: any*/,
        v2 /*: any*/,
        v12 /*: any*/,
        v13 /*: any*/,
        v9 /*: any*/,
        v8 /*: any*/,
        v7 /*: any*/,
        v10 /*: any*/,
        v1 /*: any*/,
        v17 /*: any*/,
        v18 /*: any*/,
        v6 /*: any*/,
        v3 /*: any*/,
        v0 /*: any*/,
        v16 /*: any*/,
        v14 /*: any*/,
        v11 /*: any*/,
        v5 /*: any*/,
      ],
      kind: 'Operation',
      name: 'putListingMutation',
      selections: [
        {
          alias: null,
          args: v19 /*: any*/,
          concreteType: 'InvsysPutListingResponse',
          kind: 'LinkedField',
          name: 'invsysPutListing',
          plural: false,
          selections: [
            v20 /*: any*/,
            {
              alias: null,
              args: null,
              concreteType: 'InvsysSkusListing',
              kind: 'LinkedField',
              name: 'data',
              plural: false,
              selections: v28 /*: any*/,
              storageKey: null,
            },
          ],
          storageKey: null,
        },
      ],
    },
    params: {
      cacheID: '61919452eb9fcf96cf4d18bcde391bb9',
      id: null,
      metadata: {},
      name: 'putListingMutation',
      operationKind: 'mutation',
      text: 'mutation putListingMutation(\n  $id: String\n  $title: InvsysStringPutObject\n  $description: InvsysStringPutObject\n  $skus: InvsysArray_StringRequired_RequiredPutObject\n  $tags: InvsysArray_StringRequired_RequiredPutObject\n  $notes: InvsysArray_StringRequired_RequiredPutObject\n  $mediaIds: InvsysArray_StringRequired_RequiredPutObject\n  $listingSku: InvsysStringPutObject\n  $price: InvsysFloatPutObject\n  $currencyCode: InvsysListingCurrencyCodeTypePutObject\n  $weight: InvsysFloatPutObject\n  $width: InvsysFloatPutObject\n  $length: InvsysFloatPutObject\n  $height: InvsysFloatPutObject\n  $archived: InvsysBooleanPutObject\n  $userDeleted: InvsysBooleanPutObject\n  $targetInstitutions: InvsysArray_IntRequired_PutObject\n  $searchTags: InvsysArray_StringRequired_RequiredPutObject\n  $itemOperations: InvsysArray_PutItemOperationRequired_RequiredPutObject\n) {\n  invsysPutListing(id: $id, title: $title, description: $description, skus: $skus, tags: $tags, notes: $notes, mediaIds: $mediaIds, listingSku: $listingSku, price: $price, currencyCode: $currencyCode, weight: $weight, width: $width, length: $length, height: $height, archived: $archived, userDeleted: $userDeleted, targetInstitutions: $targetInstitutions, searchTags: $searchTags, itemOperations: $itemOperations) {\n    success\n    data {\n      ...listingFragment_full\n    }\n  }\n}\n\nfragment listingFragment_full on InvsysSkusListing {\n  id\n  title\n  description\n  listingSku\n  skus\n  tags\n  notes\n  searchTags\n  marketplacesSummary {\n    marketplaces\n    draftMarketplaces\n  }\n  price {\n    id\n    currencyCode\n    val\n  }\n  createdAt\n  updatedAt\n  items {\n    id\n    title\n    description\n    brand\n    categoryId\n    sizeId\n    price {\n      currencyCode\n      val\n    }\n    retailPrice {\n      currencyCode\n      val\n    }\n    costPrice {\n      currencyCode\n      val\n    }\n    size {\n      val\n      system\n    }\n    condition\n    tags\n    skuAlias\n    colors\n    weight\n    height\n    width\n    length\n    weightUnit\n    sizeUnit\n    packageSizeType\n  }\n  archived\n  targetInstitutions\n  validationResult {\n    success\n    errors {\n      errorId: id\n      message\n      entityName\n      fieldName\n    }\n  }\n}\n',
    },
  };
})();
(node as any).hash = '4c259891295d4fe1fce682f5e19aeed2';
export default node;
